<template>
   <main v-if="dados != null">
      <section class="checkout-area py-md-5 py-3">
         <div class="container">
            <div class="row">
               <div class="col-lg-6">
                  <div class="checkbox-form">
                     <h3 class="mb-0">Meus dados
                        <span class="float-end cursor-pointer" @click="toggleEditar = false;" title="Fechar edição" v-if="toggleEditar">
                           <i class="fas fa-times font-20 mt-2"></i>
                           <span class="d-none d-xl-inline-block font-15 transform-2 ms-2"> Voltar</span>
                        </span>
                        <span class="float-end cursor-pointer" @click="toggleEditar = true;" title="Abrir edição" v-else>
                           <i class="fas fa-pen font-16 mt-2"></i>
                           <span class="d-none d-xl-inline-block font-15 transform-1 ms-2"> Editar</span>
                        </span>
                     </h3>
                     <div class="row">
                        <div class="col-12" v-if="toggleEditar">
                           <div class="your-order-table table-responsive">
                              <table>
                                 <tbody>
                                    <tr class="cart_item">
                                       <td class="w-50 product-name regulaTexto">
                                          <strong class="product-quantity"><i class="fal fa-id-card color-theme font-12 me-1"></i> CPF</strong>
                                       </td>
                                       <td class="w-50 product-total regulaTexto py-2">
                                          <input type="text" class="form-control font-14" maxlength="250" v-model="dadosEdit.cpf" v-mask="['###.###.###-##', '##.###.###/####-##']" />
                                       </td>
                                    </tr>
                                    <tr class="cart_item">
                                       <td class="w-50 product-name regulaTexto">
                                          <strong class="product-quantity"><i class="far fa-envelope color-theme font-12 me-1"></i> Email</strong>
                                       </td>
                                       <td class="w-50 product-total regulaTexto py-2">
                                          <input type="text" class="form-control font-14" maxlength="250" v-model="dadosEdit.email" />
                                       </td>
                                    </tr>
                                    <tr class="cart_item">
                                       <td class="w-50 product-name regulaTexto">
                                          <strong class="product-quantity"><i class="far fa-hashtag color-theme font-12 me-1"></i> ID Jogador</strong>
                                       </td>
                                       <td class="w-50 product-total regulaTexto py-2">
                                          <input type="text" class="form-control font-14" v-mask="'##########'" v-model="dadosEdit.idJogador" />
                                       </td>
                                    </tr>
                                    <tr class="cart_item">
                                       <td class="w-100 product-total text-end">
                                          <button class="btn bg-theme font-14" @click="salvar">Salvar</button>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                        <div class="col-12" v-else>
                           <div class="your-order-table table-responsive">
                              <table>
                                 <tbody>
                                    <tr class="cart_item">
                                       <td class="w-50 product-name regulaTexto">
                                          <strong class="product-quantity"><i class="far fa-user color-theme font-12 me-1"></i> Nome de usuário</strong>
                                       </td>
                                       <td class="w-50 product-total regulaTexto text-end">
                                          <span class="amount">{{ dados.user.login }}</span>
                                       </td>
                                    </tr>
                                    <tr class="cart_item">
                                       <td class="w-50 product-name regulaTexto">
                                          <strong class="product-quantity"><i class="far fa-male color-theme font-12 me-1"></i> Nome completo</strong>
                                       </td>
                                       <td class="w-50 product-total regulaTexto text-end">
                                          <span class="amount">{{ dados.user.nomeCompleto }}</span>
                                       </td>
                                    </tr>
                                    <tr class="cart_item">
                                       <td class="w-50 product-name regulaTexto">
                                          <strong class="product-quantity"><i class="fal fa-id-card color-theme font-12 me-1"></i> CPF</strong>
                                       </td>
                                       <td class="w-50 product-total regulaTexto text-end">
                                          <span class="amount">{{ dados.user.cpf }}</span>
                                       </td>
                                    </tr>
                                    <tr class="cart_item">
                                       <td class="w-50 product-name regulaTexto">
                                          <strong class="product-quantity"><i class="far fa-envelope color-theme font-12 me-1"></i> Email</strong>
                                       </td>
                                       <td class="w-50 product-total regulaTexto text-end">
                                          <span class="amount">{{ dados.user.email }}</span>
                                       </td>
                                    </tr>
                                    <tr class="cart_item">
                                       <td class="w-50 product-name regulaTexto">
                                          <strong class="product-quantity"><i class="far fa-hashtag color-theme font-12 me-1"></i> ID Jogador</strong>
                                       </td>
                                       <td class="w-50 product-total regulaTexto text-end">
                                          <span class="amount">{{ dados.user.idJogador }}</span>
                                       </td>
                                    </tr>
                                    <tr class="cart_item">
                                       <td class="w-100 product-total text-center text-lg-end">
                                          <button class="btn bg-danger text-white font-14" @click="deslogar">
                                             <i class="fas fa-sign-out font-12 me-1"></i> Deslogar
                                          </button>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-lg-6 mt-lg-0 mt-4">
                  <div class="checkbox-form">
                     <h3 class="mb-0" v-if="compra.toggle">Compras
                        <span class="float-end cursor-pointer" @click="compra.toggle = false;" title="Fechar compra">
                           <i class="fas fa-times font-20 mt-2"></i>
                           <span class="d-none d-xl-inline-block font-15 transform-2 ms-2"> Voltar</span>
                        </span>
                     </h3>
                     <h3 class="mb-0" v-else>Compras</h3>
                     <div class="row">
                        <div class="col-12">
                           <div class="your-order-table table-responsive">
                              <table>
                                 <tbody v-if="compra.toggle">
                                    <tr class="cart_item" v-if="compra.info.status == 'Aguardando pagamento' && compra.info.transactionUrl != null">
                                       <div class="row mx-0 mb-4">
                                          <td class="w-100 product-name regulaTexto">
                                             <strong class="product-quantity"><i class="far fa-shopping-cart color-theme font-12 me-1"></i> Pagamento</strong>
                                          </td>
                                          <td class="w-100 product-total text-end" v-if="compra.info.formaPgto == 'PagHiper'">
                                             <div class="btn-pix mx-auto" @click="refazerPgto">
                                                <img src="@/assets/cliente/img/shop/pix.png" alt="Pix" />
                                             </div>
                                          </td>
                                          <td class="w-100 product-total text-end" v-else-if="compra.info.formaPgto == 'PayPal'">
                                             <div class="btn-payPal mx-auto p-0" @click="refazerPgto">
                                                <img src="@/assets/cliente/img/shop/paypal.png" alt="PayPal" />
                                             </div>
                                          </td>
                                          <td class="w-100 product-total text-end" v-else-if="compra.info.formaPgto == 'MercadoPago'">
                                             <div class="btn-mercadoPago mx-auto" @click="refazerPgto">
                                                <img src="@/assets/cliente/img/shop/mercadoPago.png" alt="MercadoPago" />
                                             </div>
                                          </td>
                                       </div>
                                    </tr>

                                    <tr class="cart_item">
                                       <td class="w-100 product-name regulaTexto">
                                          <strong class="product-quantity"><i class="far fa-shopping-cart color-theme font-12 me-1"></i> Produtos</strong>
                                       </td>
                                    </tr>

                                    <produto v-for="(produto, index) in compra.info.produtos" :key="index" :produto="produto" :index="index" :page="'PERFIL'" />

                                    <tr class="cart__item d-flex justify-content-between align-items-center" v-if="compra.info.produtos.length == 0">
                                       <div class="cart__inner d-flex mx-auto">
                                          <div class="cart__details">
                                             <h6 class="my-5"><a href="javascript:;">Nenhum produto encontrado</a></h6>
                                          </div>
                                       </div>
                                    </tr>
                                 </tbody>

                                 <tbody v-else>
                                    <compra v-for="(compra, index) in dados.compras" :key="index" :compra="compra" @verCompra="verCompra($event)" />

                                    <tr class="cart__item d-flex justify-content-between align-items-center" v-if="dados.compras.length == 0">
                                       <div class="cart__inner d-flex mx-auto">
                                          <div class="cart__details">
                                             <h6 class="my-5"><a href="javascript:;">Nenhuma compra encontrada</a></h6>
                                          </div>
                                       </div>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   </main>
</template>

<script>

import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import compra from '@/components/perfil/Compra.vue'
import produto from '@/components/home/Carrinho.vue'

export default {
	name: 'Perfil',
   data: function() {
		return {
			dados: null,
			dadosEdit: {},
         toggleEditar: false,
         compra: {'info': null, 'toggle': false}
		}
	},
   computed: {
		... mapState({
			dadosUsuario: state => state.dadosUsuario,
			urlRest: state => state.urlRest
		})
	},
   watch: {
      toggleEditar : function (value) {
         if (value && this.dados != null) {
            this.dadosEdit.cpf = this.dados.user.cpf
            this.dadosEdit.email = this.dados.user.email
            this.dadosEdit.idJogador = this.dados.user.idJogador
         }
      }
   },
   components: {
		produto, compra
	},
   methods: {
      verCompra : function (compra) {
         this.compra.info = compra
         this.compra.toggle = true
      },
      buscarUsuario : function () {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'get',
            url: this.urlRest +'user/getuser',
            params: {
               acesso: this.dadosUsuario.cliente.acesso
            }
         }).then(function (response) {
            ref.dados = response.data

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      salvar : function () {
         let ref = this;

         Swal.fire({
            icon: 'warning',
            title: 'Salvar alterações?',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Confirmar'

         }).then((result) => {
            if (result.isConfirmed) {
               if (ref.dadosEdit.cpf == null || ref.dadosEdit.cpf.trim().length < 14) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'CPF inválido!'
                  });
      
                  return
               } else if (ref.dadosEdit.email == null || ref.dadosEdit.email.trim().length < 5) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Digite ao menos 5 caracteres no email!'
                  });
      
                  return
               } else if (ref.dadosEdit.idJogador == null || String(ref.dadosEdit.idJogador).trim().length == 0) {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'ID Jogador inválido!'
                  });
      
                  return
               }
               
               ref.$store.dispatch('alternarTelaCarregamento', true)
      
               ref.$axios({
                  method: 'post',
                  url: ref.urlRest +'user/edituser',
                  params: {
                     acesso: ref.dados.user.acesso,
                     cpf: ref.dadosEdit.cpf,
                     email: ref.dadosEdit.email,
                     idJogador: ref.dadosEdit.idJogador
                  }
               }).then(function () {
                  ref.toggleEditar = false
                  ref.buscarUsuario()
      
                  ref.$toast.fire({
                     icon: 'success',
                     title: 'Alterações salvas!'
                  });
               }).catch(function (error) {
                  if (error.response != undefined) {
                     ref.$toast.fire({
                        icon: 'error',
                        title: 'Erro: ' + error.response.status
                     });
                  } else {
                     ref.$toast.fire({
                        icon: 'error',
                        title: error
                     });
                  }
               }).finally(() => {
                  ref.$store.dispatch('alternarTelaCarregamento', false)
               });
            }
         })
      },
      deslogar : function () {
			this.$store.dispatch('deslogar')
		},
      refazerPgto : function () {
         window.open(this.compra.info.transactionUrl)
      }
   },
   created() {
      this.buscarUsuario()
   }
}

</script>